import assertNever from 'assert-never';

import { SystemStatus, SystemState } from '@shure/cloud/shared/models/devices';

import { SystemState as SysApiSystemState, SystemStatusFragment } from '../graphql/generated/cloud-sys-api';

export function mapSystemStatusFromSysApi(sysApiSystemStatus: SystemStatusFragment): SystemStatus {
	return {
		state: mapSystemStateFromSysApi(sysApiSystemStatus.state),
		writeSafe: sysApiSystemStatus.writeSafe,
		schemaChanged: !!sysApiSystemStatus.schemaChanged
	};
}

function mapSystemStateFromSysApi(sysApiSystemState: SysApiSystemState): SystemState {
	switch (sysApiSystemState) {
		case SysApiSystemState.Limited:
			return SystemState.Limited;
		case SysApiSystemState.Operational:
			return SystemState.Operational;
		case SysApiSystemState.Suspended:
			return SystemState.Suspended;
		default:
			assertNever(sysApiSystemState);
	}
}
